module.exports = __webpack_public_path__ + "img/ipgone_page5.36bfaaa7.png";